import { post,put,del,get } from './axios'

// 공지사항의 CRUD를 나열
export const insertEduGuid = async (params) => {
  const { status, data } = await post("/edu/insertEduGuidAjax", params);

  if (status === 200 || status === 201) {
    return data;
  }
};

export const updateEduGuid = async (params) => {
  const { status, data } = await post("/edu/updateEduGuidAjax", params);

  if (status === 200 || status === 201) {
    return data;
  }
};


export const updateViewCount = async (params) => {
  const { status, data } = await post("/edu/updateViewCountAjax", params);

  if (status === 200 || status === 201) {
    return data;
  }
};


export const updateEduGuidFiles = async (params) => {
  const { status, data } = await post("/edu/updateEduGuidFiles", params,true);

  if (status === 200 || status === 201) {
    return data;
  }
};

export const updateEduGuidImgFiles = async (params) => {
  const { status, data } = await post("/edu/updateEduGuidImgFiles", params,true);

  if (status === 200 || status === 201) {
    return data;
  }
};


export const deleteEduGuid = async (params) => {
  const { status, data } = await del("/edu/deleteEduGuidAjax", params);

  if (status === 200 || status === 201) {
    return data;
  }
};

export const getEduGuidDetail = async (params) => {
  const { status, data } = await get("/edu/selectEduGuidDetailAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const eduList = async (params) => {
  const { status, data } = await get("/edu/selectEduGuidAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

